// extracted by mini-css-extract-plugin
export default {"chatHistory":"ChatHistory-module__chatHistory--a8deb","historySearch":"ChatHistory-module__historySearch--d0c4a","divider":"ChatHistory-module__divider--b3979"};